// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserServiceRequest } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_CAN_USER_SVC, SUC_CAN_USER_SVC } from '../../../../utils/strings';

export const useCancelUserServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    UserServiceRequest.UserServiceRequest_Cancel,
    SUC_CAN_USER_SVC,
    ERR_CAN_USER_SVC,
  );
  return submit;
};
